exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".overview-branch-container {\n  padding: 24px;\n  border-radius: 16px;\n}\n\n.overview-branch-container .chart-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Dashboard/OverviewByBranch/OverviewByBranch.style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Dashboard/OverviewByBranch/OverviewByBranch.style.scss
// module chunks = 0